const humanize = (segment: string): string =>
    decodeURIComponent(segment)
        .replace(/\.(html?|php|aspx?)$/i, "")
        .replaceAll(/[_-]+/g, " ")
        .trim()
        .split(/\s+/)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

/**
 * Human-readable label for a source pill. We have no real page title, so we
 * derive one from the URL: the last path segment humanized, else the hostname.
 */
export const getSourceLabel = (link: string): string => {
    try {
        const { hostname, pathname } = new URL(link);
        const host = hostname.replace(/^www\./, "");
        const lastSegment = pathname.split("/").filter(Boolean).pop();
        const label = lastSegment ? humanize(lastSegment) : "";
        // A segment of only separators/extension humanizes to "" — fall back to the host.
        return label.length > 0 ? label : host;
    } catch {
        return link;
    }
};
